import { render } from "./ModeratorMessage.vue?vue&type=template&id=9d99e9ca&scoped=true&ts=true"
import script from "./ModeratorMessage.vue?vue&type=script&lang=ts"
export * from "./ModeratorMessage.vue?vue&type=script&lang=ts"

import "./ModeratorMessage.vue?vue&type=style&index=0&id=9d99e9ca&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d99e9ca"]])

export default __exports__